import PhotoGallery from './PhotoGallery'
import './PhotoGallery.css'

export default PhotoGallery



// WEBPACK FOOTER //
// ./src/components/PhotoGallery/index.js